import {required} from "vuelidate/lib/validators";  
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
const StrProsesGiris = {
  mixins: [Api, Sabit],
    data() {
      return { 
        StrProsesGirisData:{
            Id: "",
            Deleted: false,
            Donemid:"",
            Birimid:"",
            Tabloid:"",
            Aciklama:"",
            Deger: 0,
            Onay: true,
              
          },
 
      }
    },
    validations:{ 
        FormData: {
          Donemid: { required },
          Birimid: { required },
          Tabloid: { required },
          Deger: { required },
          Onay: { required },
          Aciklama: { }
           
        } 
    },


}
export default StrProsesGiris